var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00588F",
    d: "M2 0h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m14.574 9.335c.955-.08 1.602-.525 1.852-1.129-.345.217-1.414.453-2.004.228a8 8 0 0 0-.093-.399c-.45-1.693-1.99-3.056-3.605-2.892a7 7 0 0 1 .395-.15c.178-.064 1.22-.238 1.056-.615-.138-.332-1.412.25-1.652.327.317-.122.84-.332.897-.705a2.5 2.5 0 0 0-1.33.645.95.95 0 0 0 .256-.517c-1.294.846-2.05 2.553-2.66 4.21-.481-.478-.907-.853-1.288-1.062-1.071-.588-2.352-1.202-4.362-1.967-.062.682.329 1.588 1.454 2.19-.243-.033-.69.042-1.046.13.145.78.62 1.423 1.904 1.734-.587.04-.89.177-1.165.472.267.543.92 1.182 2.093 1.05-1.305.577-.532 1.643.53 1.484a4.43 4.43 0 0 1-6.306.173c4.28 5.977 13.585 3.535 14.972-2.222 1.039.01 1.65-.369 2.028-.785-.599.104-1.466-.004-1.926-.2"
  }))));
};
export default SvgTwitter;